import React, { useEffect, useState } from "react";
import { Transition, Dialog } from "@headlessui/react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { putData } from "actions";
import { API_URL_agent } from "constants/api";
import { agentReducers } from "redux/agentSlice";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ModalChangePassword = ({ isOpen, onClose, item }) => {
  const cancelButtonRef = React.useRef(null);
  const dispatch = useDispatch();
  const [visiblePassword, setVisiblePassword] = useState(false);
  const [visibleConfirmPassword, setVisibleConfirmPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(8, "Password must be at least 8 characters long")
        .required("Password is required"),
      confirmPassword: Yup.string()
        .min(8, "Password must be at least 8 characters long")
        .required("Confirm Password is required")
        .test("passwords-match", "Passwords must match", function (value) {
          return this.parent.password === value;
        }),
    }),
    onSubmit: (values) => {
      const formData = values;
      putData(
        `${API_URL_agent}${item.id}/`,
        formData,
        { dispatch, redux: agentReducers },
        "ADD_AGENT"
      );
      // Reset formik state
      formik.resetForm();

      // Tutup modal
      onClose();
    },
  });

  useEffect(() => {
    // Reset formik state
    formik.resetForm();
  }, [onClose]);

  return (
    <Transition.Root show={isOpen} as={React.Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-start justify-center p-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-al w-full lg:w-1/2">
                <form onSubmit={formik.handleSubmit}>
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="mt-3 sm:ml-4 sm:mt-0">
                      <div className="flex justify-between">
                        <Dialog.Title
                          as="h3"
                          className="text-2xl font-semibold leading-6 text-gray-900"
                        >
                          Change Password
                        </Dialog.Title>
                        <button
                          type="button"
                          className=" bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                          onClick={onClose}
                        >
                          X
                        </button>
                      </div>
                      <hr className="my-2" />
                      <div className="px-6 py-1">
                        <label htmlFor="link" className="block mb-1">
                          Password
                        </label>
                        <input
                          type={visiblePassword ? "text" : "password"}
                          id="password"
                          name="password"
                          className="w-full p-2 border border-gray-300 rounded-md"
                          value={formik.values.password}
                          onChange={formik.handleChange}
                        />
                        <div
                          className="absolute text-gray-400 top-[115px] right-14 text-2xl cursor-pointer"
                          onClick={() => setVisiblePassword(!visiblePassword)}
                        >
                          {visiblePassword ? <FaEye /> : <FaEyeSlash />}
                        </div>
                        {formik.touched.password && formik.errors.password && (
                          <div className="text-red-500 dark:text-red-300 text-xs">
                            {formik.errors.password}
                          </div>
                        )}
                      </div>
                      <div className="px-6 py-1">
                        <label htmlFor="link" className="block mb-1">
                          Confirm Password
                        </label>
                        <input
                          type={visibleConfirmPassword ? "text" : "password"}
                          id="confirmPassword"
                          name="confirmPassword"
                          className="w-full p-2 border border-gray-300 rounded-md"
                          value={formik.values.confirmPassword}
                          onChange={formik.handleChange}
                        />
                        <div
                          className="absolute text-gray-400 top-[195px] right-14 text-2xl cursor-pointer"
                          onClick={() =>
                            setVisibleConfirmPassword(!visibleConfirmPassword)
                          }
                        >
                          {visibleConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                        </div>
                        {formik.touched.confirmPassword &&
                          formik.errors.confirmPassword && (
                            <div className="text-red-500 dark:text-red-300 text-xs">
                              {formik.errors.confirmPassword}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 flex justify-between px-4 py-3 sm:px-6">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                      onClick={onClose}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="inline-flex justify-center rounded-md bg-sky-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-600"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ModalChangePassword;
